'use client';

import { CheckoutProvider } from './checkout-context';
import CheckoutContent from './checkout-content';

// Re-export types for external use
export type { CheckoutStep } from './checkout-context';

export interface CheckoutFlowProps {
  /** Initial tier from URL param or modal prop */
  initialTier?: string;
  /** Initial period (years) from URL param */
  initialPeriod?: string;
  /** Source identifier for tracking (from legacy website) */
  initialSource?: string;
  /** URL to redirect to after successful purchase */
  successUrl?: string;
  /** Callback when user closes checkout */
  onClose?: () => void;
  /** Callback after successful purchase */
  onSuccess?: () => void;
  /** Whether checkout is rendered in embedded/iframe mode (affects SSR handling) */
  embedded?: boolean;
}

export default function CheckoutFlow(props: CheckoutFlowProps) {
  return (
    <CheckoutProvider {...props}>
      <CheckoutContent />
    </CheckoutProvider>
  );
}
